<router-outlet></router-outlet>
<b2b-portal-notification></b2b-portal-notification>
